msgid ""
msgstr ""
"POT-Creation-Date: 2026-01-18 16:02+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: fi\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: pkg.totalPriceMonthly
#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "{0} €/mo"
msgstr "{0} €/kk"

#. placeholder {0}: warrantyStats.active
#: src/modules/maintenance/Summary.tsx
msgid "{0} active"
msgstr "{0} voimassa"

#. placeholder {0}: formatDate(visitDate)
#. placeholder {1}: visitDate.toLocaleTimeString( 'fi-FI', { hour: '2-digit', minute: '2-digit', }, )
#. placeholder {2}: endTime.toLocaleTimeString('fi-FI', { hour: '2-digit', minute: '2-digit', })
#: src/routes/_app/visits/index.tsx
msgid "{0} at {1}-{2}"
msgstr "{0} klo {1}-{2}"

#. placeholder {0}: warrantyStats.expiringSoon
#: src/modules/maintenance/Summary.tsx
msgid "{0} expiring soon"
msgstr "{0} päättyy pian"

#. placeholder {0}: visits.length
#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "{0} of {totalVisits} visits"
msgstr "{0} / {totalVisits} käyntiä"

#. placeholder {0}: taskAttachments.length
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "{0} photos"
msgstr "{0} kuvaa"

#. placeholder {0}: company.properties?.length || 0
#: src/routes/_app/company-portal/index.tsx
msgid "{0} properties"
msgstr "{0} kohdetta"

#. placeholder {0}: category.taskCount
#: src/modules/maintenance/Summary.tsx
msgid "{0} tasks"
msgstr "{0} tehtävää"

#. placeholder {0}: pkg.quantity
#. placeholder {1}: pkg.priceMonthly
#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "{0} x {1} €/mo ="
msgstr "{0} x {1} €/kk ="

#. placeholder {0}: hasDiscount ? effectivePrice : basePrice
#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
msgid "{0}€/mo"
msgstr "{0}€/kk"

#: src/modules/visit/FutureVisit.tsx
msgid "{attendeeCount} attendees"
msgstr "{attendeeCount} osallistujaa"

#: src/modules/home/components/MaintenanceCard.tsx
msgid "{completedCount}/{totalCount} done"
msgstr "{completedCount}/{totalCount} tehty"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "{dayName} {dateStr} at {startTimeStr} - {endTimeStr}"
msgstr "{dayName} {dateStr} klo {startTimeStr} - {endTimeStr}"

#: src/routes/_app/maintenance-log/index.tsx
msgid "{itemYear} maintenance activities"
msgstr "Vuoden {itemYear} toimenpiteet"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "{priceMonthly} €/mo"
msgstr "{priceMonthly} €/kk"

#: src/modules/visit/FutureVisit.tsx
msgid "{taskCount} tasks"
msgstr "{taskCount} tehtävää"

#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "{totalVisits} visits"
msgstr "{totalVisits} käyntiä"

#: src/components/VisitListItem.tsx
msgid "{weekday} {day}. {month}, at {startTimeStr}-{endTimeStr}"
msgstr "{weekday} {day}. {month}, klo {startTimeStr}-{endTimeStr}"

#: src/modules/visit/FutureVisit.tsx
msgid "~{estimatedDuration} min"
msgstr "~{estimatedDuration} min"

#: src/components/profile/CustomerCard.tsx
#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
#: src/modules/subscription/components/PackageCard.tsx
msgid "€/mo"
msgstr "€/kk"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "1. Close your apartment's water shutoff valve"
msgstr "1. Sulje asuntosi vesisulku"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "12 tasks done, 36 remaining"
msgstr "12 tehtävää tehty, 36 jäljellä"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "135,00 € / pcs"
msgstr "135,00 € / kpl"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "2. Call the emergency hotline at 020 7484 00"
msgstr "2. Soita hätäpäivystykseen numeroon 020 7484 00"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "24-hour service"
msgstr "Päivystys ympäri vuorokauden"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "24/7 service - including Christmas and Midsummer"
msgstr "Päivystys 24/7 - myös jouluna ja juhannuksena"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "3. Mention at the start of the call that you are a Markku.fi customer. Explain what happened and follow the instructions given to you."
msgstr "3. Mainitse puhelun alussa olevasi Markku.fi asiakas. Kerro, mitä on tapahtunut ja noudata sinulle annettavia ohjeita."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "4. File a claim with your insurance company"
msgstr "4. Tee vahinkoilmoitus vakuutusyhtiöllesi"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "5. Add the damage report from Polygon to your Markku maintenance log."
msgstr "5. Lisää Polygonilta tuleva vahinkoraportti Markku-huoltokirjaasi."

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "7 days"
msgstr "7 päivää"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "A centralized place for all home information and images"
msgstr "Keskitetty paikka kaikille kodin tiedoille ja kuville"

#: src/modules/auth/WelcomeStep.tsx
msgid "A maintenance book that takes care of your home. Track maintenance needs, receive reminders and maintain your property's value."
msgstr "Huoltokirja, joka pitää huolen kodistasi. Seuraa huoltotarpeita, vastaanota muistutuksia ja pidä kiinteistösi arvossa."

#. placeholder {0}: task.estimatedDurationHours
#: src/modules/maintenance/YearCalendarCarousel/index.tsx
msgid "About {0} hours"
msgstr "Noin {0} tuntia"

#. placeholder {0}: task.estimatedDurationMinutes
#: src/routes/_app/maintenance-log/$id.tsx
msgid "About {0} minutes"
msgstr "Noin {0} minuuttia"

#: src/modules/auth/WelcomeStep.tsx
msgid "Accept terms of service"
msgstr "Hyväksy käyttöehdot"

#: src/modules/subscription/components/PackageCard.tsx
#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "Activate package"
msgstr "Aktivoi paketti"

#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
#: src/modules/subscription/components/PackageCard.tsx
#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
#: src/routes/_app/company-portal/$companyId/index.tsx
msgid "Active"
msgstr "Aktiivinen"

#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
msgid "Active subscription"
msgstr "Aktiivinen tilaus"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
#: src/modules/costs/CostsPage/CostsMonthlyChart.tsx
#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Actual"
msgstr "Toteutunut"

#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
#: src/modules/maintenanceLog/detail/CostSummaryCard.tsx
msgid "Actual cost"
msgstr "Toteutunut kustannus"

#: src/modules/consumption/ConsumptionSummaryCards.tsx
#: src/modules/consumption/index.tsx
#: src/modules/costs/CostsPage/index.tsx
#: src/routes/_app/maintenance-log/index.tsx
msgid "Add"
msgstr "Lisää"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Add a detailed description of the task..."
msgstr "Lisää tarkempi kuvaus tehtävästä..."

#: src/components/common/AttachmentField.tsx
msgid "Add attachment"
msgstr "Lisää liite"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Add cost"
msgstr "Lisää kustannus"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Add costs in the <0>Maintenance log</0>"
msgstr "Lisää kustannuksia <0>Huoltokirjassa</0>"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Add meter reading"
msgstr "Lisää mittarilukema"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Add more detailed description..."
msgstr "Lisää tarkempi kuvaus..."

#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
msgid "Add notes about the completed work..."
msgstr "Lisää muistiinpanoja suoritetusta työstä..."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Add notes about the task..."
msgstr "Lisää muistiinpanot tehtävästä..."

#: src/components/profile/AddPropertyModal.tsx
#: src/components/profile/CustomerCard.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/profile.tsx
msgid "Add property"
msgstr "Lisää kiinteistö"

#: src/modules/maintenance/YearCalendarCarousel/TaskCard.tsx
msgid "Add task"
msgstr "Lisää tehtävä"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Add to calendar"
msgstr "Lisää kalenteriin"

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/profile.tsx
msgid "Add your first property"
msgstr "Lisää ensimmäinen kiinteistösi"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Additional charges: mileage compensation €1.65/km (car/van), €2.40/km (truck), materials at Polygon list price -25% + material surcharge 12%, HVAC work and subcontracting +12%."
msgstr "Lisäksi veloitetaan: kilometrikorvaus 1,65 € / km (henkilö-/pakettiauto), 2,40 € / km (kuorma-auto), materiaalit Polygonin listahinta -25 % + materiaalilisä 12 %, LVIS-työt ja alihankinnat +12 %."

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Additional info..."
msgstr "Lisätietoja..."

#: src/modules/visit/FutureVisit.tsx
msgid "Additional information"
msgstr "Lisätiedot"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Additional information (optional)"
msgstr "Lisätiedot (valinnainen)"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Additional work"
msgstr "Lisätyöt"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Additional work will be added to your next monthly invoice automatically"
msgstr "Lisätyöt lisätään seuraavalle kuukausilaskulle automaattisesti"

#: src/modules/property/components/PropertyAddressCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Address"
msgstr "Osoite"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Address is required"
msgstr "Osoite on pakollinen"

#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "After"
msgstr "Jälkeen"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Alert!"
msgstr "Hälytys!"

#: src/routes/_app/maintenance-log/index.tsx
msgid "All categories"
msgstr "Kaikki kohteet"

#: src/modules/home/components/EngagementCard.tsx
msgid "All maintenance supplies included in the price"
msgstr "Kaikki huoltotarvikkeet sisältyvät hintaan"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "All OK"
msgstr "Kaikki OK"

#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "All properties"
msgstr "Kaikki kohteet"

#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "All statuses"
msgstr "Kaikki tilat"

#. placeholder {0}: allowedTypes.join(', ')
#: src/components/common/AttachmentField.tsx
msgid "Allowed types: {0}"
msgstr "Sallitut tyypit: {0}"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Amount"
msgstr "Summa"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Annual calendar"
msgstr "Vuosikello"

#: src/components/profile/LanguageSettings.tsx
msgid "App language"
msgstr "Sovelluksen kieli"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Are you sure you want to delete this maintenance entry?"
msgstr "Haluatko varmasti poistaa tämän huoltomerkinnän?"

#. placeholder {0}: Number(consumption.meterReading).toFixed(1)
#. placeholder {1}: consumption.unit
#. placeholder {2}: formatDate(consumption.date)
#: src/modules/consumption/ConsumptionTable.tsx
msgid "Are you sure you want to delete this meter reading ({0} {1}, {2})?"
msgstr "Haluatko varmasti poistaa tämän mittarilukeman ({0} {1}, {2})?"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Are you sure you want to delete this task?"
msgstr "Haluatko varmasti poistaa tämän tehtävän?"

#: src/routes/_app/profile.tsx
msgid "Are you sure you want to log out?"
msgstr "Haluatko varmasti kirjautua ulos?"

#: src/routes/_app/messages/index.tsx
msgid "Ask questions, request help and track visits"
msgstr "Kysy, pyydä apua ja seuraa käyntejä"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/BookingSummary.tsx
msgid "at"
msgstr "klo"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Attachments"
msgstr "Liitteet"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Attachments are saved when the task is saved"
msgstr "Liitteet tallennetaan tehtävän tallennuksen yhteydessä"

#: src/modules/visit/FutureVisit.tsx
msgid "Attendees"
msgstr "Osallistujat"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Autumn"
msgstr "Syksy"

#: src/modules/auth/EmailStep.tsx
#: src/modules/auth/OtpStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Back"
msgstr "Takaisin"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Barcode"
msgstr "Viivakoodi"

#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "Before"
msgstr "Ennen"

#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
#: src/modules/subscription/components/ServicePromotionCard.tsx
msgid "Book a free survey visit"
msgstr "Varaa ilmainen kartoituskäynti"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Book visit"
msgstr "Varaa käynti"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Booking successful!"
msgstr "Varaus onnistui!"

#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Budget variance"
msgstr "Budjettiero"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
#: src/modules/costs/CostsPage/CostsMonthlyChart.tsx
#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Budgeted"
msgstr "Budjetoitu"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Budgeted costs are calculated from task estimates"
msgstr "Budjetoidut kustannukset lasketaan tehtävien arvioista"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Budgeting and household deduction"
msgstr "Budjetointi ja kotitalousvähennys"

#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/visit/FeedbackModal.tsx
#: src/routes/_app/maintenance-log/$id.tsx
#: src/routes/_app/profile.tsx
msgid "Cancel"
msgstr "Peruuta"

#: src/routes/_app/company-portal/$companyId/visits/index.tsx
#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "Cancelled"
msgstr "Peruutettu"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
#: src/routes/_app/maintenance-log/index.tsx
msgid "Category"
msgstr "Kohde"

#: src/modules/visit/PastVisit/DocumentsCard.tsx
msgid "Certificate"
msgstr "Todistus"

#: src/components/company-portal/PropertyDocuments.tsx
msgid "Certificates"
msgstr "Todistukset"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Certificates and user manuals"
msgstr "Todistukset ja käyttöohjeet"

#: src/modules/maintenance/Summary.tsx
msgid "Certificates, manuals and receipts"
msgstr "Todistukset, käyttöohjeet ja kuitit"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Change package"
msgstr "Vaihda pakettia"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Check"
msgstr "Tarkista"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Check details"
msgstr "Tarkista tiedot"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Check form details"
msgstr "Tarkista lomakkeen tiedot"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Check the form data"
msgstr "Tarkista lomakkeen tiedot"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Check your contact information"
msgstr "Tarkista yhteystietosi"

#. placeholder {0}: form.values.email
#: src/modules/auth/EmailStep.tsx
msgid "Check your email {0}"
msgstr "Tarkista sähköpostisi {0}"

#: src/modules/visit/PastVisit/DocumentsCard.tsx
msgid "Chimney sweep certificate"
msgstr "Nuohoustodistus"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "Choose a suitable time for the survey visit"
msgstr "Valitse sopiva ajankohta kartoituskäynnille"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "City"
msgstr "Kaupunki"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Click the \"Add\" button on the card you want (electricity, water, or heating)"
msgstr "Klikkaa \"Lisää\"-painiketta haluamallasi kortilla (sähkö, vesi tai lämmitys)"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
#: src/modules/subscription/components/ContractTermsModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Close"
msgstr "Sulje"

#: src/modules/auth/OtpStep.tsx
msgid "Code must be 6 digits"
msgstr "Koodin tulee olla 6 numeroa"

#: src/modules/auth/EmailStep.tsx
msgid "Code sent!"
msgstr "Koodi lähetetty!"

#: src/routes/_app/company-portal/$companyId/index.tsx
#: src/routes/_app/company-portal/$companyId/index.tsx
msgid "Company not found"
msgstr "Yritystä ei löytynyt"

#: src/routes/_app/company-portal/$companyId/index.tsx
#: src/routes/_app/company-portal/index.tsx
#: src/routes/_app/company-portal/index.tsx
#: src/routes/_app/company-portal/index.tsx
msgid "Company portal"
msgstr "Yritysportaali"

#: src/modules/consumption/ConsumptionChart.tsx
msgid "Comparison to previous year"
msgstr "Vertailu edelliseen vuoteen"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
#: src/routes/_app/company-portal/$companyId/visits/index.tsx
#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "Completed"
msgstr "Suoritettu"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Completed maintenance task"
msgstr "Suoritettu huoltotehtävä"

#: src/routes/_app/maintenance-log/index.tsx
msgid "Completed maintenance tasks"
msgstr "Tehdyt huoltotehtävät"

#: src/modules/maintenanceLog/detail/CompletedStepsCard.tsx
msgid "Completed steps"
msgstr "Suoritetut vaiheet"

#: src/modules/visit/PastVisit/CompletedTasksList.tsx
msgid "Completed tasks"
msgstr "Hoidetut toimenpiteet"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Completion date is required"
msgstr "Suorituspäivämäärä on pakollinen"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Completion date is required when marking task as completed"
msgstr "Suorituspäivämäärä on pakollinen kun merkitset tehtävän tehdyksi"

#: src/components/profile/AddPropertyModal.tsx
msgid "Construction year"
msgstr "Rakennusvuosi"

#: src/modules/consumption/index.tsx
#: src/modules/consumption/index.tsx
#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
msgid "Consumption tracking"
msgstr "Kulutusseuranta"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Consumption type"
msgstr "Kulutustyyppi"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Contact"
msgstr "Ota yhteyttä"

#: src/routes/_app/company-portal/$companyId/index.tsx
msgid "Contact Markku support to add properties to your company account."
msgstr "Ota yhteyttä Markkuun lisätäksesi kohteita yritystilillesi."

#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "Contents:"
msgstr "Sisältö:"

#: src/modules/auth/EmailStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "Continue"
msgstr "Jatka"

#: src/modules/auth/GoogleButton.tsx
msgid "Continue with Google"
msgstr "Jatka Google-tilillä"

#: src/modules/subscription/components/ContractTermsModal.tsx
msgid "Contract terms – Markku.fi Home Services"
msgstr "Sopimusehdot – Markku.fi Pientalopalvelut"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Copied"
msgstr "Kopioitu"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Copy"
msgstr "Kopioi"

#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Cost"
msgstr "Kustannus"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Cost breakdown"
msgstr "Kustannuserittely"

#: src/modules/maintenanceLog/detail/CostSummaryCard.tsx
msgid "Cost information"
msgstr "Kustannustiedot"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Cost management"
msgstr "Kustannusten hallinta"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Cost name"
msgstr "Kustannuksen nimi"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Cost name is required"
msgstr "Kustannuksen nimi on pakollinen"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Cost saved"
msgstr "Kustannus tallennettu"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Cost tracking"
msgstr "Kustannusseuranta"

#: src/modules/costs/CostsPage/index.tsx
#: src/modules/costs/CostsPage/index.tsx
msgid "Costs"
msgstr "Kustannukset"

#: src/modules/costs/CostsPage/CostsCategoryList.tsx
msgid "Costs by category"
msgstr "Kustannukset kategorioittain"

#: src/modules/maintenance/components/FinancialQuickCard.tsx
msgid "Costs for {year}"
msgstr "Vuoden {year} kustannukset"

#. placeholder {0}: formatEuros(totalCost)
#: src/modules/maintenance/YearCalendarCarousel/SeasonHeader.tsx
msgid "Costs: {0}"
msgstr "Kustannukset: {0}"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Create new task"
msgstr "Luo uusi tehtävä"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Current"
msgstr "Nykyinen"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Customer comment:"
msgstr "Asiakkaan kommentti:"

#: src/components/profile/CustomerCard.tsx
msgid "Customer name"
msgstr "Asiakkuuden nimi"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Customer rating:"
msgstr "Asiakkaan arvio:"

#: src/routes/_app/messages/index.tsx
msgid "Customer service"
msgstr "Asiakaspalvelu"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Damage prevention (JVT)"
msgstr "Jälkivahingontorjunta (JVT)"

#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Date"
msgstr "Päivämäärä"

#: src/modules/visit/FutureVisit.tsx
msgid "Date and time"
msgstr "Ajankohta"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Date is required"
msgstr "Päivämäärä on pakollinen"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Deadline is required"
msgstr "Määräaika on pakollinen"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "December-February"
msgstr "Joulu-Helmikuu"

#: src/modules/visit/PastVisit/DefectsNotesCard.tsx
msgid "Defects and deficiencies"
msgstr "Viat ja puutteet"

#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/routes/_app/maintenance-log/$id.tsx
#: src/routes/_app/maintenance-log/$id.tsx
msgid "Delete"
msgstr "Poista"

#: src/modules/consumption/ConsumptionTable.tsx
msgid "Delete consumption"
msgstr "Poista kulutus"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Delete entry"
msgstr "Poista merkintä"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Delete task"
msgstr "Poista tehtävä"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Description"
msgstr "Kuvaus"

#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
msgid "Details"
msgstr "Tiedot"

#: src/routes/_app/profile.tsx
msgid "Developer settings"
msgstr "Kehittäjäasetukset"

#: src/modules/home/components/EngagementCard.tsx
msgid "Did you know?"
msgstr "Tiesitkö?"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Digital maintenance book"
msgstr "Digitaalinen huoltokirja"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Digital maintenance log"
msgstr "Sähköinen huoltokirja"

#: src/routes/_app/messages/index.tsx
msgid "Direct communication with maintenance staff"
msgstr "Suora viestintä huoltohenkilön kanssa"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Do you only see one package?"
msgstr "Näetkö vain yhden paketin?"

#: src/components/company-portal/PropertyDocuments.tsx
msgid "Document"
msgstr "Dokumentti"

#: src/components/company-portal/PropertyDocuments.tsx
#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
#: src/modules/visit/PastVisit/DocumentsCard.tsx
msgid "Documents"
msgstr "Dokumentit"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Documents and warranties"
msgstr "Dokumentit ja takuut"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Doe"
msgstr "Meikäläinen"

#: src/modules/subscription/components/ContractTermsModal.tsx
msgid "Download contract terms (PDF)"
msgstr "Lataa sopimusehdot (PDF)"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Download invoice (PDF)"
msgstr "Lataa lasku (PDF)"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Due"
msgstr "Eräpäivä"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Due date"
msgstr "Eräpäivä"

#: src/modules/visit/PastVisit/PropertySurveyCard.tsx
msgid "During the visit, your property information was surveyed and updated."
msgstr "Käynnillä kartoitettiin ja päivitettiin kiinteistösi tiedot."

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 00100"
msgstr "Esim. 00100"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 123 Main Street"
msgstr "Esim. Esimerkkikatu 1"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 150"
msgstr "Esim. 150"

#: src/modules/property/components/PropertyAddressCard.tsx
msgid "E.g. 150"
msgstr "Esim. 150"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 2010"
msgstr "Esim. 2010"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. Helsinki"
msgstr "Esim. Helsinki"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "E.g. Mannerheimintie 1"
msgstr "Esim. Mannerheimintie 1"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "E.g. Pipe renovation, HVAC maintenance"
msgstr "Esim. Putkiremontti, LVI-huolto"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "E.g. property age, condition, or other information that may help with the survey visit"
msgstr "Esim. kiinteistön ikä, kunto, tai muita tietoja jotka voivat auttaa kartoituskäynnillä"

#: src/modules/maintenance/components/TaskDetails/index.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "E.g. Window cleaning"
msgstr "Esim. Ikkunoiden pesu"

#: src/routes/_app/messages/index.tsx
msgid "Easily arrange visit times"
msgstr "Sopikaa käyntiajat helposti"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/routes/_app/maintenance-log/$id.tsx
msgid "Edit"
msgstr "Muokkaa"

#: src/components/profile/CustomerCard.tsx
msgid "Edit customer"
msgstr "Muokkaa asiakkuutta"

#: src/components/profile/PersonalInfoCard.tsx
msgid "Edit information"
msgstr "Muokkaa tietoja"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Edit meter reading"
msgstr "Muokkaa mittarilukemaa"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Edit or delete costs by opening an individual maintenance entry"
msgstr "Muokkaa tai poista kustannuksia avaamalla yksittäinen huoltomerkintä"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Edit task"
msgstr "Muokkaa tehtävää"

#: src/modules/maintenance/Summary.tsx
msgid "Electrical systems"
msgstr "Sähköjärjestelmät"

#: src/modules/consumption/ConsumptionChart.tsx
#: src/modules/consumption/utils.ts
#: src/modules/consumption/utils.ts
msgid "Electricity"
msgstr "Sähkö"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
msgid "Electricity, water and heating"
msgstr "Sähkö, vesi ja lämmitys"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/auth/EmailStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Email"
msgstr "Sähköposti"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Email address cannot be changed"
msgstr "Sähköpostiosoitetta ei voi muuttaa"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Emergency call fee"
msgstr "Hälytyskorvaus"

#: src/modules/home/components/EngagementCard.tsx
msgid "Emergency repairs 24/7"
msgstr "Kiireelliset korjaukset 24/7"

#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "End date"
msgstr "Loppupäivä"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Enter the current meter reading. Consumption is calculated automatically from the previous reading."
msgstr "Syötä mittarin nykyinen lukema. Kulutus lasketaan automaattisesti edellisestä lukemasta."

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Enter the current meter reading. This will serve as the starting point for consumption calculation."
msgstr "Syötä mittarin nykyinen lukema. Tämä toimii lähtöpisteenä kulutuksen laskentaan."

#: src/modules/property/components/PropertyAddressCard.tsx
msgid "Enter the total floor area to see all suitable packages"
msgstr "Anna kokonaispinta-ala nähdäksesi kaikki sopivat paketit"

#: src/modules/auth/OtpStep.tsx
msgid "Enter verification code"
msgstr "Syötä vahvistuskoodi"

#: src/modules/auth/EmailStep.tsx
msgid "Enter your email address"
msgstr "Syötä sähköpostiosoitteesi"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Enter your property's total floor area in the card above, and we'll show you all suitable Markku packages."
msgstr "Anna kiinteistösi kokonaispinta-ala yllä olevassa kortissa, niin näemme sinulle kaikki sopivat Markku-paketit."

#: src/components/ErrorAlert.tsx
#: src/components/profile/AddPropertyModal.tsx
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/invoice.ts
#: src/lib/trpcHooks/user.ts
#: src/lib/trpcHooks/user.ts
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/visit/FeedbackModal.tsx
#: src/routes/impersonate.tsx
msgid "Error"
msgstr "Virhe"

#: src/modules/maintenanceLog/detail/CostSummaryCard.tsx
msgid "Estimate"
msgstr "Arvio"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Estimated cost (optional)"
msgstr "Arvioitu kustannus (vapaaehtoinen)"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/BookingSummary.tsx
msgid "Estimated end time at"
msgstr "Arvioitu päättymisaika klo"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Estimated end time at {formattedEndTime}"
msgstr "Arvioitu päättymisaika klo {formattedEndTime}"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Example Street 1"
msgstr "Esimerkkikatu 1"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Explore Markku packages"
msgstr "Tutustu Markku-paketteihin"

#: src/modules/maintenance/components/MarkkuSavingsCard.tsx
msgid "Explore packages"
msgstr "Tutustu paketteihin"

#: src/modules/maintenance/Summary.tsx
msgid "Facade"
msgstr "Julkisivu"

#: src/lib/trpcHooks/billing.ts
msgid "Failed to accept offer"
msgstr "Tarjouksen hyväksyminen epäonnistui"

#: src/lib/trpcHooks/billing.ts
msgid "Failed to create payment session"
msgstr "Maksusession luominen epäonnistui"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Failed to delete task"
msgstr "Tehtävän poistaminen epäonnistui"

#: src/components/ErrorAlert.tsx
msgid "Failed to load data. Please try again."
msgstr "Tietojen lataaminen epäonnistui. Yritä uudelleen."

#: src/lib/trpcHooks/billing.ts
msgid "Failed to open billing portal"
msgstr "Laskutusportaalin avaaminen epäonnistui"

#: src/lib/trpcHooks/invoice.ts
msgid "Failed to open payment page"
msgstr "Maksusivun avaaminen epäonnistui"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Failed to save cost"
msgstr "Kustannuksen tallentaminen epäonnistui"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Failed to save task"
msgstr "Tehtävän tallentaminen epäonnistui"

#: src/lib/trpcHooks/user.ts
msgid "Failed to update information"
msgstr "Tietojen päivitys epäonnistui"

#: src/lib/trpcHooks/user.ts
msgid "Failed to update settings"
msgstr "Asetusten päivitys epäonnistui"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Fall tasks"
msgstr "Syksyn tehtävät"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "fall's"
msgstr "syksyn"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "First meter reading"
msgstr "Ensimmäinen mittarilukema"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "First name"
msgstr "Etunimi"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "First name is required"
msgstr "Etunimi on pakollinen"

#: src/components/profile/AddPropertyModal.tsx
msgid "Floor area in square meters (m²)"
msgstr "Kerrosala neliömetreinä (m²)"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Follow seasonal maintenance tasks and keep your home in shape all year round"
msgstr "Seuraa kausikohtaisia huoltotöitä ja pidä koti kunnossa ympäri vuoden"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "FREE"
msgstr "ILMAINEN"

#: src/modules/visit/FeedbackModal.tsx
msgid "Free feedback (optional)"
msgstr "Vapaa palaute (valinnainen)"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Free maintenance program for your property"
msgstr "Ilmainen kiinteistösi huolto-ohjelma"

#: src/components/profile/AddPropertyModal.tsx
msgid "Free-form notes about the property"
msgstr "Vapaamuotoisia muistiinpanoja kiinteistöstä"

#: src/modules/maintenance/Summary.tsx
msgid "Full maintenance history"
msgstr "Koko huoltohistoria"

#: src/modules/home/components/EngagementCard.tsx
msgid "Get a free month when your friend joins"
msgstr "Saat kuukauden ilmaiseksi kun ystäväsi liittyy"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Get additional help at home"
msgstr "Hanki lisäapua kotiin"

#: src/modules/auth/WelcomeStep.tsx
msgid "Get started"
msgstr "Aloita käyttö"

#: src/modules/subscription/components/NoSubscriptionCard.tsx
msgctxt "subscription"
msgid "Get started"
msgstr "Aloita"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Get tips for home maintenance and special offers from our partners"
msgstr "Saat vinkkejä kodin huoltoon ja erikoistarjouksia kumppaneiltamme"

#: src/components/VisitListItem.tsx
#: src/modules/home/components/EngagementCard.tsx
#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Give feedback"
msgstr "Anna palautetta"

#: src/modules/visit/FeedbackModal.tsx
msgid "Great that the visit went well!"
msgstr "Hienoa, että käynti meni hyvin!"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Gutter cleaning"
msgstr "Rännien puhdistus"

#: src/modules/consumption/ConsumptionChart.tsx
#: src/modules/consumption/utils.ts
#: src/modules/consumption/utils.ts
msgid "Heating"
msgstr "Lämmitys"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Heating summer setting"
msgstr "Lämmityksen kesäasetus"

#: src/modules/maintenance/Summary.tsx
msgid "Heating systems"
msgstr "Lämmitysjärjestelmät"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Helps with budgeting and annual planning"
msgstr "Auttaa budjetoinnissa ja vuosisuunnittelussa"

#: src/config/navigation.tsx
msgid "Home"
msgstr "Koti"

#: src/modules/home/components/EngagementCard.tsx
#: src/modules/visit/FeedbackModal.tsx
msgid "How did the visit go?"
msgstr "Miten käynti meni?"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "How did the visit go? Your feedback helps us improve our service."
msgstr "Miten käynti meni? Palautteesi auttaa meitä kehittämään palvelua."

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "How to get started:"
msgstr "Näin aloitat:"

#: src/modules/visit/FeedbackModal.tsx
msgid "How would you rate Markku's visit?"
msgstr "Miten arvioisit Markun käyntiä?"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Humidity"
msgstr "Kosteus"

#: src/modules/maintenance/Summary.tsx
msgid "HVAC systems"
msgstr "LVI-järjestelmät"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "I accept the"
msgstr "Hyväksyn"

#: src/modules/subscription/components/PackageCard.tsx
msgid "I accept the <0>contract terms</0>"
msgstr "Hyväksyn <0>sopimusehdot</0>"

#: src/modules/auth/WelcomeStep.tsx
msgid "I accept the <0>terms of service</0> and <1>privacy policy</1>"
msgstr "Hyväksyn <0>käyttöehdot</0> ja <1>tietosuojaselosteen</1>"

#: src/components/property/WelcomePropertyModal.tsx
msgid "I want to receive Markku maintenance offers and benefits"
msgstr "Haluan saada Markun huoltotarjouksia ja etuja"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "IBAN"
msgstr "IBAN"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "If you are interested in our services, contact us:"
msgstr "Jos olet kiinnostunut palveluistamme, ota yhteyttä:"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "If you have questions about this task or notice a problem, contact our customer service."
msgstr "Jos sinulla on kysyttävää tästä tehtävästä tai havaitset ongelman, ota yhteyttä asiakaspalveluumme."

#: src/routes/impersonate.tsx
msgid "Impersonation failed"
msgstr "Impersonointi epäonnistui"

#: src/routes/impersonate.tsx
msgid "Impersonation successful"
msgstr "Impersonointi onnistui"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "In many cases, the insurance company will reimburse the costs of damage prevention, but each case is handled individually."
msgstr "Useissa tapauksissa vakuutusyhtiö korvaa jälkivahinkojen torjunnasta Sinulle aiheutuneet kustannukset, mutta jokainen tapaus käsitellään erikseen."

#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "In progress"
msgstr "Käynnissä"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Includes:"
msgstr "Sisältää:"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Indoor air specialist"
msgstr "Sisäilma-asiantuntija"

#: src/lib/trpcHooks/user.ts
#: src/lib/trpcHooks/user.ts
msgid "Information updated"
msgstr "Tiedot päivitetty"

#: src/modules/auth/EmailStep.tsx
msgid "Invalid email address"
msgstr "Virheellinen sähköpostiosoite"

#: src/components/common/AttachmentField.tsx
msgid "Invalid file type"
msgstr "Virheellinen tiedostotyyppi"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Invalid phone number"
msgstr "Virheellinen puhelinnumero"

#: src/modules/home/components/EngagementCard.tsx
msgid "Invite a friend"
msgstr "Kutsu ystävä"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoice"
msgstr "Lasku"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoice will be sent shortly. Payment period is 14 days."
msgstr "Lasku lähetetään pian. Maksuaika 14 vrk."

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoiced work:"
msgstr "Laskutetut työt:"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoices"
msgstr "Laskut"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "John"
msgstr "Matti"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "June-August"
msgstr "Kesä-Elokuu"

#: src/routes/_app/company-portal/$companyId/properties/$propertyId/index.tsx
msgid "Kohteen käynnit"
msgstr "Kohteen käynnit"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Last name"
msgstr "Sukunimi"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Last name is required"
msgstr "Sukunimi on pakollinen"

#: src/routes/_app/company-portal/$companyId/properties/$propertyId/index.tsx
msgid "Last visit"
msgstr "Viimeisin käynti"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Lawn spring maintenance"
msgstr "Nurmikon kevätkunnostus"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "LEAK!"
msgstr "VUOTO!"

#: src/modules/home/components/EngagementCard.tsx
msgid "Learn about Markku service"
msgstr "Tutustu Markku-palveluun"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
msgid "Leave empty if no costs incurred"
msgstr "Jätä tyhjäksi jos ei aiheuttanut kustannuksia"

#: src/modules/maintenance/components/MarkkuSavingsCard.tsx
msgid "Less worry, more time"
msgstr "Vähemmän huolia, enemmän aikaa"

#: src/modules/subscription/components/NoSubscriptionCard.tsx
msgid "Let Markku take care of it!"
msgstr "Anna Markun hoitaa!"

#: src/modules/maintenance/Summary.tsx
msgid "List of all maintenance records"
msgstr "Listaus kaikista huolloista"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Live"
msgstr "Live"

#: src/components/profile/AddPropertyModal.tsx
msgid "Living area"
msgstr "Asuinpinta-ala"

#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "Load more visits"
msgstr "Lataa lisää käyntejä"

#: src/modules/maintenance/YearCalendarCarousel/index.tsx
msgid "Loading maintenance tasks..."
msgstr "Ladataan huoltotehtäviä..."

#: src/modules/maintenance/Summary.tsx
msgid "Loading summary..."
msgstr "Ladataan yhteenvetoa..."

#: src/routes/_app/messages/$id.tsx
msgid "Loading..."
msgstr "Ladataan..."

#: src/modules/visit/FutureVisit.tsx
msgid "Location"
msgstr "Sijainti"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Locking"
msgstr "Lukitus"

#: src/modules/auth/OtpStep.tsx
msgid "Log in"
msgstr "Kirjaudu"

#: src/components/company-portal/UserEmailBadge.tsx
#: src/routes/_app/profile.tsx
#: src/routes/_app/profile.tsx
#: src/routes/_app/profile.tsx
msgid "Log out"
msgstr "Kirjaudu ulos"

#: src/modules/auth/OtpStep.tsx
msgid "Login code"
msgstr "Kirjautumiskoodi"

#: src/modules/auth/WelcomeLogin.tsx
msgid "Login required"
msgstr "Kirjautuminen vaaditaan"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Maintain property information"
msgstr "Ylläpitämään kiinteistötietoja"

#: src/config/navigation.tsx
msgid "Maintenance"
msgstr "Huoltokirja"

#: src/modules/maintenance/Summary.tsx
msgid "Maintenance categories"
msgstr "Huoltokategoriat"

#: src/modules/maintenance/YearCalendarCarousel/HistoryLinkCard.tsx
#: src/routes/_app/maintenance-log/index.tsx
msgid "Maintenance history"
msgstr "Huoltohistoria"

#: src/routes/_app/visits/index.tsx
msgid "Maintenance history and visit records"
msgstr "Huoltohistoria ja käyntikirjaukset"

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
msgid "Maintenance log"
msgstr "Huoltokirja"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Maintenance task"
msgstr "Huoltotehtävä"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Maintenance task not found"
msgstr "Huoltotehtävää ei löytynyt"

#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
msgid "Manage"
msgstr "Hallinnoi"

#: src/components/profile/CustomerCard.tsx
msgid "Manage payment method and invoices"
msgstr "Hallinnoi maksutapaa ja laskuja"

#: src/modules/maintenance/Summary.tsx
msgid "Manage property information"
msgstr "Hallinnoi kodin tietoja"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Manage your subscription"
msgstr "Hallinnoi tilaustasi"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "March-May"
msgstr "Maalis-Toukokuu"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Mark as completed"
msgstr "Merkitse tehdyksi"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Markku currently serves the Helsinki metropolitan area and its surroundings."
msgstr "Markku palvelee tällä hetkellä pääkaupunkiseudulla ja sen lähialueilla."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Markku customer prices (incl. VAT 25.5%):"
msgstr "Markku asiakkaiden hinnat (sis. ALV 25,5 %):"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "Markku handles"
msgstr "Markku hoitaa"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Markku handles this task"
msgstr "Markku hoitaa tämän tehtävän"

#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
#: src/routes/_app/properties/$propertyId/index.tsx
msgid "Markku package"
msgstr "Markku-paketti"

#: src/routes/_app/maintenance-services.tsx
msgid "Markku packages"
msgstr "Markku-paketit"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "Markku recommends for you"
msgstr "Markku suosittelee sinulle"

#: src/modules/home/components/EngagementCard.tsx
msgid "Markku service includes:"
msgstr "Markku-palvelu sisältää:"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Markku service technician"
msgstr "Markku-huoltohenkilö"

#: src/routes/_app/visits/index.tsx
msgid "Markku takes care of your home maintenance"
msgstr "Markku hoitaa kotisi huollon puolestasi"

#: src/routes/_app/visits/index.tsx
msgid "Markku.fi is a home maintenance service in the Helsinki metropolitan area. After activating your subscription, Markku will regularly visit your home to handle the maintenance tasks included in the contract and, if needed, small repairs and installations."
msgstr "Markku.fi on kodin huoltopalvelu pääkaupunkiseudulla. Tilauksen aktivoinnin jälkeen Markku käy kodissasi säännöllisesti hoitamassa sopimukseen kuuluvat huoltotehtävät ja tarvittaessa pieniä korjaus- ja asennustöitä."

#: src/routes/_app/messages/index.tsx
msgid "Markku.fi subscribers can message directly with maintenance staff to arrange visit times, ask questions and request help with small repairs or installations."
msgstr "Markku.fi palvelun tilaajat voivat viestiä suoraan huoltohenkilön kanssa sopiakseen käyntiaikoja, esittääkseen kysymyksiä ja pyytääkseen apua esimerkiksi pieniin korjaus- tai asennustarpeisiin."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Markku.fi survey visit"
msgstr "Markku.fi kartoituskäynti"

#: src/modules/home/components/UpcomingVisitCard.tsx
#: src/routes/_app/visits/index.tsx
msgid "Markku's next visit"
msgstr "Markun seuraava käynti"

#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
#: src/modules/visit/PastVisit/VisitNotesCard.tsx
msgid "Markku's notes"
msgstr "Markun huomiot"

#: src/routes/_app/visits/index.tsx
msgid "Markku's visits"
msgstr "Markun käynnit"

#: src/components/profile/CustomerCard.tsx
#: src/components/profile/CustomerCard.tsx
msgid "Member"
msgstr "Jäsen"

#: src/components/profile/CustomerCard.tsx
msgid "Members"
msgstr "Jäsenet"

#: src/config/navigation.tsx
#: src/routes/_app/messages/index.tsx
#: src/routes/_app/messages/index.tsx
#: src/routes/_app/messages/index.tsx
msgid "Messages"
msgstr "Viestit"

#: src/routes/_app/messages/index.tsx
msgid "Messages with Markku"
msgstr "Viestit Markun kanssa"

#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/consumption/ConsumptionTable.tsx
msgid "Meter reading"
msgstr "Mittarilukema"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Meter reading must be positive"
msgstr "Mittarilukeman on oltava positiivinen"

#: src/modules/consumption/ConsumptionTable.tsx
msgid "Meter readings"
msgstr "Mittarilukemat"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Moisture/fire damage assessment"
msgstr "Kosteus-/palovahinkokartoitus"

#: src/modules/consumption/ConsumptionChart.tsx
msgid "Monthly consumption"
msgstr "Kulutus kuukausittain"

#: src/modules/costs/CostsPage/CostsMonthlyChart.tsx
msgid "Monthly costs"
msgstr "Kustannukset kuukausittain"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "My tasks"
msgstr "Omat tehtävät"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Name"
msgstr "Nimi"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "New"
msgstr "Uusi"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "New additional work will be added automatically to your next monthly invoice. You don't need to do anything."
msgstr "Uudet lisätyöt lisätään automaattisesti seuraavalle kuukausilaskulle. Sinun ei tarvitse tehdä mitään."

#: src/modules/home/components/ActivityFeed.tsx
msgid "News"
msgstr "Ajankohtaista"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Next time, consumption is calculated automatically: new reading - previous reading"
msgstr "Seuraavalla kerralla kulutus lasketaan automaattisesti: uusi lukema - edellinen lukema"

#: src/modules/home/components/ServiceStatusCard.tsx
#: src/routes/_app/company-portal/$companyId/properties/$propertyId/index.tsx
msgid "Next visit"
msgstr "Seuraava käynti"

#: src/routes/_app/visits/index.tsx
msgid "Next visit will be arranged separately"
msgstr "Seuraava käynti sovitaan erikseen"

#: src/components/profile/CustomerCard.tsx
msgid "No active subscription"
msgstr "Ei aktiivista tilausta"

#: src/routes/_app/company-portal/$companyId/index.tsx
msgid "No address"
msgstr "Ei osoitetta"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "No available times for the selected day, check the next day."
msgstr "Ei vapaita aikoja valitulle päivälle, katso seuraava päivä."

#: src/routes/_app/company-portal/index.tsx
msgid "No company accounts found"
msgstr "Yritystilejä ei löytynyt"

#: src/routes/_app/maintenance-log/index.tsx
msgid "No completed maintenance tasks with selected filters"
msgstr "Ei tehtyjä huoltotehtäviä valituilla suodattimilla"

#: src/routes/_app/messages/index.tsx
msgid "No conversations yet"
msgstr "Ei keskusteluja vielä"

#: src/routes/_app/maintenance.tsx
msgid "No customer"
msgstr "Ei asiakkuutta"

#: src/components/company-portal/PropertyDocuments.tsx
msgid "No documents"
msgstr "Ei dokumentteja"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "No Markku tasks for this season"
msgstr "Ei Markun tehtäviä tälle kaudelle"

#: src/routes/_app/messages/index.tsx
msgid "No messages yet - start a conversation"
msgstr "Ei viestejä vielä - aloita keskustelu"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "No personal tasks for this season"
msgstr "Ei omia tehtäviä tälle kaudelle"

#: src/components/profile/CustomerCard.tsx
#: src/routes/_app/company-portal/$companyId/index.tsx
msgid "No properties"
msgstr "Ei kiinteistöjä"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "No recommended tasks for this season"
msgstr "Ei suositeltuja tehtäviä tälle kaudelle"

#: src/modules/subscription/components/NoSubscriptionCard.tsx
msgid "No stress, no hard work - just a well-maintained home"
msgstr "Ei stressiä, ei työleiriä - vain hyvin hoidettu koti"

#: src/components/VisitListItem.tsx
msgid "No tasks"
msgstr "Ei tehtäviä"

#: src/routes/_app/visits/index.tsx
msgid "No upcoming visits"
msgstr "Ei tulevia käyntejä"

#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "No visits found"
msgstr "Käyntejä ei löytynyt"

#. placeholder {0}: step.notes
#: src/modules/maintenanceLog/detail/CompletedStepsCard.tsx
msgid "Note: {0}"
msgstr "Huomio: {0}"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Note: If the work is covered by an insurance company, the prices agreed between Polygon and the insurance company apply."
msgstr "Huom: Jos työ korvataan vakuutusyhtiön toimesta, sovelletaan Polygonin ja vakuutusyhtiön välisen sopimuksen mukaisia hintoja."

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Notes"
msgstr "Muistiinpanot"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Notes (optional)"
msgstr "Muistiinpanot (valinnainen)"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Notes about the task (optional)"
msgstr "Muistiinpanot tehtävästä (valinnainen)"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Notes saved"
msgstr "Muistiinpanot tallennettu"

#: src/modules/home/components/Header.tsx
msgid "Notifications"
msgstr "Ilmoitukset"

#: src/modules/maintenance/components/YearSummaryCard.tsx
msgid "Of the year's <0>{totalTasks}</0> tasks, <1>Markku handles {markkuTasks}</1>, saving you approximately <2>{savedHours} hours</2>."
msgstr "Vuoden <0>{totalTasks}</0> tehtävästä <1>Markku hoitaa {markkuTasks}</1>, säästäen sinulta arviolta <2>{savedHours} tuntia</2>."

#: src/modules/subscription/components/PackageCard.tsx
msgid "Only the owner can subscribe to packages"
msgstr "Vain omistaja voi tilata paketteja"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Open"
msgstr "Avoinna"

#: src/modules/maintenance/YearCalendarCarousel/HistoryLinkCard.tsx
msgid "Open history"
msgstr "Avaa historia"

#: src/modules/home/components/MaintenanceCard.tsx
msgid "Open maintenance book"
msgstr "Avaa huoltokirja"

#: src/modules/auth/WelcomeStep.tsx
msgid "or"
msgstr "tai"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Order additional services"
msgstr "Tilaa lisäpalveluita"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Other"
msgstr "Muu"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Other address"
msgstr "Muu osoite"

#: src/components/company-portal/PropertyDocuments.tsx
msgid "Other documents"
msgstr "Muut dokumentit"

#: src/modules/subscription/components/ServicePromotionCard.tsx
msgid "Our customer service is open on weekdays 8-16"
msgstr "Asiakaspalvelumme on auki arkisin klo 8-16"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Outside service area"
msgstr "Palvelualueen ulkopuolella"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Overdue"
msgstr "Erääntynyt"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Overtime and additional fees: Overtime is charged according to actual hours with percentage increases per the Technology Industry Workers' Collective Agreement. Holiday eve +100% (previous weekday 18:00 – next day 06:00), Public holiday +100% (previous weekday/Saturday 18:00 – next weekday 06:00)."
msgstr "Ylityöt ja lisäkorvaukset: Ylityöt veloitetaan toteuman mukaan Teknologiateollisuuden työntekijöiden työehtosopimuksen mukaisilla prosenttikorotuksilla. Aattokorvaus +100 % (edellinen arki klo 18.00 – seuraava vuorokausi klo 06.00), Pyhätyö +100 % (edellinen arki/lauantai klo 18.00 – seuraava arki klo 06.00)."

#: src/routes/_app/properties/$propertyId/index.tsx
msgid "Overview"
msgstr "Yleistä"

#: src/components/profile/CustomerCard.tsx
#: src/components/profile/CustomerCard.tsx
msgid "Owner"
msgstr "Omistaja"

#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "Package"
msgstr "Paketti"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Paid"
msgstr "Maksettu"

#. placeholder {0}: formatDate(paidDate)
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Paid {0}"
msgstr "Maksettu {0}"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Paid work:"
msgstr "Maksetut työt:"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Part of the Markku package"
msgstr "Osa Markku-pakettia"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Partially paid"
msgstr "Osittain maksettu"

#: src/routes/_app/company-portal/$companyId/visits/$visitId.tsx
#: src/routes/_app/visits/$id.tsx
msgid "Past visit"
msgstr "Mennyt käynti"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Pay now"
msgstr "Maksa nyt"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Payment"
msgstr "Maksu"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "PDF invoice download failed. Please try again later."
msgstr "PDF-laskun lataus epäonnistui. Yritä myöhemmin uudelleen."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Peace of mind and time savings"
msgstr "Mielenrauha ja ajansäästö"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Peace of mind around the clock"
msgstr "Mielenrauhaa ympäri vuorokauden"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Performed by"
msgstr "Suorittaja"

#: src/components/profile/NotificationSettings.tsx
msgid "Permission denied in browser"
msgstr "Käyttöoikeus evätty selaimessa"

#: src/components/profile/PersonalInfoCard.tsx
msgid "Personal information"
msgstr "Omat tiedot"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Phone number"
msgstr "Puhelinnumero"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Phone number is required"
msgstr "Puhelinnumero on pakollinen"

#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Photos"
msgstr "Kuvat"

#: src/modules/visit/PastVisit/DefectsNotesCard.tsx
msgid "Photos and videos"
msgstr "Kuvat ja videot"

#: src/modules/visit/FutureVisit.tsx
msgid "Planned tasks"
msgstr "Suunnitellut toimenpiteet"

#: src/components/profile/AddPropertyModal.tsx
msgid "Please fill in all required fields"
msgstr "Täytä kaikki pakolliset kentät"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Pool"
msgstr "Allas"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Postal code"
msgstr "Postinumero"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Postal code is required"
msgstr "Postinumero on pakollinen"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Postal code must be 5 digits"
msgstr "Postinumeron tulee olla 5 numeroa"

#. placeholder {0}: calculation.previousReading.toFixed(1)
#. placeholder {1}: form.values.unit
#. placeholder {2}: formatDate(calculation.previousDate!)
#: src/modules/consumption/ConsumptionModal.tsx
msgid "Previous reading: {0} {1} ({2})"
msgstr "Edellinen lukema: {0} {1} ({2})"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Price"
msgstr "Hinta"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Products and services:"
msgstr "Tuotteet ja palvelut:"

#: src/routes/_app/visits/index.tsx
msgid "Professional maintenance staff handles the tasks"
msgstr "Ammattitaitoinen huoltohenkilö hoitaa tehtävät"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Professionals handle the tasks"
msgstr "Ammattilaiset hoitavat tehtävät"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Professionals on site quickly"
msgstr "Ammattilaiset paikalle nopeasti"

#: src/config/navigation.tsx
#: src/routes/_app/profile.tsx
msgid "Profile"
msgstr "Profiili"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Project management"
msgstr "Työnjohto"

#: src/components/company-portal/CompanyPortalNav.tsx
#: src/components/profile/CustomerCard.tsx
msgid "Properties"
msgstr "Kiinteistöt"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
#: src/routes/_app/company-portal/$companyId/properties/$propertyId/index.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/properties/$propertyId/index.tsx
msgid "Property"
msgstr "Kiinteistö"

#. placeholder {0}: p.id
#: src/routes/_app/company-portal/$companyId/visits/index.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
msgid "Property {0}"
msgstr "Kiinteistö {0}"

#: src/components/property/WelcomePropertyModal.tsx
#: src/components/property/WelcomePropertyModal.tsx
#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Property details"
msgstr "Kiinteistötiedot"

#: src/modules/visit/PastVisit/PropertySurveyCard.tsx
msgid "Property information updated"
msgstr "Kiinteistötiedot päivitetty"

#: src/routes/_app/company-portal/$companyId/properties/$propertyId/index.tsx
#: src/routes/_app/company-portal/$companyId/properties/$propertyId/index.tsx
msgid "Property not found"
msgstr "Kohdetta ei löytynyt"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Property type"
msgstr "Kiinteistötyyppi"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Property type is required"
msgstr "Kiinteistön tyyppi on pakollinen"

#: src/components/profile/NotificationSettings.tsx
msgid "Push notifications"
msgstr "Push-ilmoitukset"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "QR code"
msgstr "QR-koodi"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Quick actions"
msgstr "Pikavalinnat"

#: src/components/profile/NotificationSettings.tsx
msgid "Receive notifications"
msgstr "Vastaanota ilmoituksia"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Recipient"
msgstr "Saaja"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Recommended for you"
msgstr "Suositeltu sinulle"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "Recommended tasks"
msgstr "Suositellut tehtävät"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Reference"
msgstr "Viite"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Regular maintenance - no surprises"
msgstr "Säännölliset huollot - ei yllätyksiä"

#: src/modules/home/components/EngagementCard.tsx
msgid "Regular maintenance visits from professionals"
msgstr "Säännölliset huoltokäynnit ammattilaiselta"

#: src/routes/_app/visits/index.tsx
msgid "Regular maintenance visits year-round"
msgstr "Säännölliset huoltokäynnit ympäri vuoden"

#. placeholder {0}: invoice.voidedInvoice.invoiceNumber
#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Replaces invoice {0}"
msgstr "Korvaa laskun {0}"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Reschedule visit"
msgstr "Siirrä käynti"

#: src/modules/auth/OtpStep.tsx
msgid "Resend code"
msgstr "Lähetä koodi uudelleen"

#: src/modules/maintenance/Summary.tsx
msgid "Roof and attic"
msgstr "Katto ja yläpohja"

#: src/components/profile/AddPropertyModal.tsx
#: src/components/profile/CustomerCard.tsx
#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Save"
msgstr "Tallenna"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Save failed"
msgstr "Tallentaminen epäonnistui"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Save home details, photos and technical system documentation"
msgstr "Tallenna kodin tiedot, kuvat ja teknisten järjestelmien dokumentaatio"

#: src/modules/visit/FeedbackModal.tsx
msgid "Saving feedback failed. Please try again."
msgstr "Palautteen tallentaminen epäonnistui. Yritä uudelleen."

#: src/modules/visit/PastVisit/WireTransferModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Scan with your banking app"
msgstr "Skannaa pankkisovelluksella"

#: src/modules/visit/FutureVisit.tsx
#: src/routes/_app/company-portal/$companyId/visits/index.tsx
#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "Scheduled"
msgstr "Suunniteltu"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Select a suitable Markku package for your property. We handle all necessary maintenance and keep your property in good condition."
msgstr "Valitse kiinteistöllesi sopiva Markku-paketti. Hoitamme kaiken tarvittavan huollon ja pidämme kiinteistösi kunnossa."

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Select category"
msgstr "Valitse kohde"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Select city"
msgstr "Valitse kaupunki"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Select date"
msgstr "Valitse päivämäärä"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "Select date and time"
msgstr "Valitse päivä ja aika"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Select day"
msgstr "Valitse päivä"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Select package"
msgstr "Valitse paketti"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Select property"
msgstr "Valitse kiinteistö"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Select target"
msgstr "Valitse kohde"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Select type"
msgstr "Valitse tyyppi"

#: src/routes/_app/maintenance-log/index.tsx
msgid "Select year"
msgstr "Valitse vuosi"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "September-November"
msgstr "Syys-Marraskuu"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Service"
msgstr "Palvelu"

#: src/modules/subscription/components/ServicePromotionCard.tsx
msgid "Service available in the Helsinki metropolitan area and nearby regions"
msgstr "Palvelu saatavilla pääkaupunkiseudulla ja sen lähialueilla"

#: src/modules/home/components/EngagementCard.tsx
msgid "Share your invite link"
msgstr "Jaa kutsulinkkisi"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Show all"
msgstr "Näytä kaikki"

#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
msgid "Show contract terms"
msgstr "Näytä sopimusehdot"

#: src/routes/_app/profile.tsx
msgid "Show placeholder content"
msgstr "Näytä placeholder-sisältö"

#. placeholder {0}: userData.firstName
#. placeholder {1}: userData.lastName
#: src/routes/impersonate.tsx
msgid "Signed in as {0} {1}"
msgstr "Kirjauduttu käyttäjänä {0} {1}"

#: src/modules/auth/GoogleButton.tsx
#: src/modules/auth/GoogleCallback.tsx
#: src/routes/impersonate.tsx
msgid "Signing in..."
msgstr "Kirjaudutaan sisään..."

#: src/modules/visit/FeedbackModal.tsx
msgid "Sorry that the visit didn't meet your expectations"
msgstr "Pahoittelut, että käynti ei täyttänyt odotuksiasi"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Special cleaning"
msgstr "Erikoispuhdistus"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Spring"
msgstr "Kevät"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Spring tasks"
msgstr "Kevään tehtävät"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "spring's"
msgstr "kevään"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Start by adding a property"
msgstr "Aloita lisäämällä kiinteistö"

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/profile.tsx
msgid "Start by adding a property for the maintenance log"
msgstr "Aloita lisäämällä kiinteistö huoltokirjaa varten"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Start consumption tracking"
msgstr "Aloita kulutusseuranta"

#: src/routes/_app/company-portal/$companyId/visits/index.tsx
msgid "Start date"
msgstr "Alkupäivä"

#. placeholder {0}: index + 1
#: src/modules/maintenanceLog/detail/CompletedStepsCard.tsx
msgid "Step {0}"
msgstr "Vaihe {0}"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Store documents"
msgstr "Säilyttämään dokumentteja"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Store warranties, receipts and important documents safely in one place"
msgstr "Säilytä takuut, kuitit ja tärkeät asiakirjat turvassa yhdessä paikassa"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Street address"
msgstr "Katuosoite"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Street address is required"
msgstr "Katuosoite on pakollinen"

#: src/modules/visit/FeedbackModal.tsx
msgid "Submit feedback"
msgstr "Lähetä palaute"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Subscribe to package"
msgstr "Tilaa paketti"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Success"
msgstr "Onnistui"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Summer"
msgstr "Kesä"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Summer tasks"
msgstr "Kesän tehtävät"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "summer's"
msgstr "kesän"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Survey visit - Markku.fi"
msgstr "Kartoituskäynti - Markku.fi"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Take care of your home easily. Markku helps you track your property's maintenance work, store important documents and maintain your home's value."
msgstr "Pidä huolta kodistasi helposti. Markku auttaa sinua seuraamaan kiinteistösi huoltotöitä, säilyttämään tärkeitä dokumentteja ja pitämään kodin arvon yllä."

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Target"
msgstr "Kohde"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Task"
msgstr "Tehtävä"

#. placeholder {0}: index + 1
#: src/modules/visit/FutureVisit.tsx
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "Task {0}"
msgstr "Toimenpide {0}"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Task deadline"
msgstr "Tehtävän määräaika"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Task deleted"
msgstr "Tehtävä poistettu"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Task details"
msgstr "Huoltotehtävän tiedot"

#: src/modules/maintenance/components/TaskDetails/index.tsx
msgid "Task is already completed"
msgstr "Tehtävä on jo tehty"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Task marked as completed"
msgstr "Tehtävä merkitty tehdyksi"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Task not found"
msgstr "Tehtävää ei löytynyt"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Task saved"
msgstr "Tehtävä tallennettu"

#: src/modules/maintenance/components/TaskDetails/index.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Task title"
msgstr "Tehtävän otsikko"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Task title is required"
msgstr "Tehtävän otsikko on pakollinen"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Task to be handled"
msgstr "Hoidettava tehtävä"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Task type"
msgstr "Tehtävän tyyppi"

#. placeholder {0}: getSeasonName(deadlineSeason)
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Task will be added to the {0} list based on the deadline"
msgstr "Tehtävä lisätään {0} listalle määräajan perusteella"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "tasks"
msgstr "tehtävää"

#: src/modules/visit/FeedbackModal.tsx
msgid "Tell us how we could serve you better..."
msgstr "Kerro miten voisimme palvella sinua paremmin..."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Tell us the property location and type"
msgstr "Kerro meille kiinteistön sijainti ja tyyppi"

#: src/modules/visit/FeedbackModal.tsx
msgid "Tell us what you especially appreciated about the visit..."
msgstr "Kerro mitä erityisesti arvostit käynnissä..."

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Temperature"
msgstr "Lämpötila"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "terms and conditions"
msgstr "sopimusehdot"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Terrace maintenance"
msgstr "Terassin kunnostus"

#. placeholder {0}: user.firstName
#. placeholder {1}: user.lastName
#: src/components/ImpersonationBanner.tsx
msgid "Test mode: Logged in as {0} {1}"
msgstr "Testaustila: Kirjautuneena käyttäjänä {0} {1}"

#: src/modules/visit/FeedbackModal.tsx
msgid "Thank you for your feedback"
msgstr "Kiitos palautteestasi"

#: src/modules/visit/FeedbackModal.tsx
msgid "Thank you for your feedback!"
msgstr "Kiitos palautteestasi!"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "The additional work listed below will be added automatically to your next monthly invoice. You don't need to do anything."
msgstr "Alla olevat lisätyöt lisätään automaattisesti seuraavalle kuukausilaskulle. Sinun ei tarvitse tehdä mitään."

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "The annual calendar reminds you of seasonal maintenance tasks"
msgstr "Vuosikello muistuttaa sinua kausikohtaisista huoltotöistä"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "The apartment's water shutoff valve is usually found in your apartment's utility room near the main water meter."
msgstr "Asunnon vesisulku löytyy useimmiten asuntosi teknisestä tilasta päävesimittarin yhteydestä."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "The call is directed to our partner Polygon's emergency service, which is available 24/7. In addition to water damage, you can report minor fire damage, such as when smoke has entered the apartment."
msgstr "Puhelu ohjautuu yhteistyökumppanimme Polygonin päivystykseen, joka on auki aina (24/7). Vuotovahinkojen lisäksi voit ilmoittaa hätäpäivystykseen pienistä palovahingoista, esim. kun savua on päässyt asuntoon."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "The customer relationship is established between you and Polygon during the call. They will bill you directly for the emergency visit and damage prevention. We have negotiated the discounted prices shown below for Markku customers."
msgstr "Asiakassuhde syntyy puhelussa Sinun ja Polygonin välille. He laskuttavat Sinua suoraan hätätilannekäynnistä ja jälkivahinkojen torjunnasta. Olemme neuvotelleet Markku asiakkaille alla näkyvät alennetut hinnat Polygonin palveluihin."

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "The maintenance book helps you:"
msgstr "Huoltokirja auttaa sinua:"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "The visit takes about an hour"
msgstr "Käynnin kesto on noin tunti"

#: src/routes/_app/messages/$id.tsx
msgid "This is a shared conversation - all members of your household can read and send messages"
msgstr "Tämä on jaettu keskustelu - kaikki kotitaloutesi jäsenet voivat lukea ja lähettää viestejä"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "This maintenance task is part of the Markku package. When you get the package, professionals will handle this task for you."
msgstr "Tämä huoltotehtävä kuuluu Markku-pakettiin. Kun hankitset paketin, ammattilaiset hoitavat tämän tehtävän puolestasi."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "This maintenance task is part of your Markku service agreement. Markku's professionals will handle this task for you according to the agreed schedule."
msgstr "Tämä huoltotehtävä kuuluu Markku-palvelusopimukseesi. Markkun ammattilaiset hoitavat tämän tehtävän puolestasi sovitun aikataulun mukaisesti."

#: src/modules/consumption/ConsumptionModal.tsx
msgid "This will serve as the starting point. The next reading will show consumption."
msgstr "Tämä toimii lähtöpisteenä. Seuraava lukema näyttää kulutuksen."

#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
msgid "Time"
msgstr "Aika"

#: src/components/property/WelcomePropertyModal.tsx
msgid "To maintenance log"
msgstr "Huoltokirjaan"

#: src/routes/_app/visits/index.tsx
msgid "Today"
msgstr "Tänään"

#: src/routes/_app/visits/index.tsx
msgid "Tomorrow"
msgstr "Huomenna"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Total"
msgstr "Yhteensä"

#: src/modules/property/components/PropertyAddressCard.tsx
msgid "Total floor area"
msgstr "Kokonaispinta-ala"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Total paid"
msgstr "Maksettu yhteensä"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Track annual maintenance"
msgstr "Seuraamaan vuosihuoltoja"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Track your electricity, water, and heating consumption using meter readings."
msgstr "Seuraa sähkö-, vesi- ja lämmityskulutustasi mittarilukemien avulla."

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
msgid "Tracking and summary"
msgstr "Seuranta ja yhteenveto"

#: src/modules/consumption/ConsumptionTable.tsx
msgid "Type"
msgstr "Tyyppi"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Unfortunately, we do not yet serve your selected area."
msgstr "Valitettavasti emme vielä palvele valitsemaasi aluetta."

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Uninvoiced total"
msgstr "Laskuttamatta yhteensä"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Uninvoiced work:"
msgstr "Laskuttamattomat työt:"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Unlock all features"
msgstr "Avaa kaikki ominaisuudet"

#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Unnamed file"
msgstr "Nimetön tiedosto"

#: src/routes/_app/company-portal/$companyId/visits/$visitId.tsx
#: src/routes/_app/visits/$id.tsx
msgid "Upcoming visit"
msgstr "Tuleva käynti"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Upgrade to Markku service"
msgstr "Päivitä Markku-palveluun"

#: src/modules/maintenance/Summary.tsx
msgid "Ventilation"
msgstr "Ilmanvaihto"

#: src/modules/visit/PastVisit/VisitNotesCard.tsx
msgid "Video summary"
msgstr "Videotiivistelmä"

#: src/modules/maintenance/YearCalendarCarousel/HistoryLinkCard.tsx
msgid "View all completed maintenance tasks"
msgstr "Näytä kaikki tehdyt huoltotehtävät"

#: src/modules/home/components/QuickActionsList.tsx
msgid "View maintenance history and tasks"
msgstr "Katso huoltohistoria ja tehtävät"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/visit/PastVisit/PropertySurveyCard.tsx
msgid "View property details"
msgstr "Katso kiinteistön tiedot"

#: src/modules/home/components/UpcomingVisitCard.tsx
msgid "View visit details"
msgstr "Katso käynnin tiedot"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Virtual barcode"
msgstr "Virtuaaliviivakoodi"

#: src/modules/visit/FeedbackModal.tsx
#: src/routes/_app/company-portal/$companyId/visits/$visitId.tsx
#: src/routes/_app/visits/$id.tsx
msgid "Visit"
msgstr "Käynti"

#: src/modules/home/components/EngagementCard.tsx
msgid "Visit 28.4.2025 - Matti Meikäläinen"
msgstr "Käynti 28.4.2025 - Matti Meikäläinen"

#: src/modules/visit/FutureVisit.tsx
msgid "Visit details"
msgstr "Käynnin tiedot"

#: src/routes/_app/visits/index.tsx
msgid "Visit history"
msgstr "Käyntihistoria"

#: src/routes/_app/company-portal/$companyId/visits/$visitId.tsx
#: src/routes/_app/company-portal/$companyId/visits/$visitId.tsx
#: src/routes/_app/visits/$id.tsx
#: src/routes/_app/visits/$id.tsx
msgid "Visit not found"
msgstr "Käyntiä ei löytynyt"

#: src/components/company-portal/PropertyDocuments.tsx
#: src/modules/visit/PastVisit/DocumentsCard.tsx
msgid "Visit report"
msgstr "Käyntiraportti"

#: src/components/company-portal/PropertyDocuments.tsx
msgid "Visit reports"
msgstr "Käyntiraportit"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Visit summary"
msgstr "Käynnin yhteenveto"

#: src/components/company-portal/CompanyPortalNav.tsx
#: src/config/navigation.tsx
#: src/routes/_app/company-portal/$companyId/visits/index.tsx
#: src/routes/_app/visits/index.tsx
msgid "Visits"
msgstr "Käynnit"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Voided"
msgstr "Mitätöity"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
msgid "Warranties"
msgstr "Takuut"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Warranties, receipts and important documents safe in one place"
msgstr "Takuut, kuitit ja tärkeät asiakirjat turvassa yhdessä paikassa"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Warranty certificates and reminders"
msgstr "Takuutodistukset ja muistutukset"

#: src/modules/consumption/ConsumptionChart.tsx
#: src/modules/consumption/utils.ts
#: src/modules/consumption/utils.ts
msgid "Water"
msgstr "Vesi"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage doesn't choose a time. We are there when you need us."
msgstr "Vuotovahingot eivät valitse aikaa. Me olemme paikalla, kun tarvitset."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage emergency 24/7"
msgstr "Vuotovahingon hätäapu 24/7"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage emergency help"
msgstr "Vuotovahingon hätäapu"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage emergency service included in all Markku packages"
msgstr "Vuotovahinkopäivystys sisältyy kaikkiin Markku-paketteihin"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Water leak"
msgstr "Vesivuoto"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "We are constantly expanding our service area!"
msgstr "Laajennamme palvelualuettamme jatkuvasti!"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "We don't charge an invoicing fee. Thank you for paying on time!"
msgstr "Emme veloita laskutuslisää. Kiitos kun maksat ajoissa!"

#: src/modules/auth/OtpStep.tsx
msgid "We sent a 6-digit code to:"
msgstr "Lähetimme 6-numeroisen koodin osoitteeseen:"

#: src/routes/_app/messages/$id.tsx
msgid "We serve weekdays 8am-4pm"
msgstr "Palvelemme arkisin klo 8-16"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "We will book the survey visit with these details"
msgstr "Näillä tiedoilla varaamme kartoituskäynnin"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "We will contact you before the visit using these details."
msgstr "Otamme sinuun yhteyttä ennen käyntiä näihin yhteystietoihin."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "We will contact you before the visit."
msgstr "Otamme sinuun vielä yhteyttä ennen käyntiä."

#: src/modules/auth/EmailStep.tsx
msgid "We will send a login code to your email"
msgstr "Lähetämme kirjautumiskoodin sähköpostilla"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "We will use these details to book your survey visit"
msgstr "Näillä tiedoilla varaamme kartoituskäynnin"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Welcome to Markku maintenance book"
msgstr "Tervetuloa Markku-huoltokirjaan"

#: src/modules/auth/WelcomeStep.tsx
msgid "Welcome to Markku!"
msgstr "Tervetuloa Markkuun!"

#: src/modules/visit/FeedbackModal.tsx
msgid "What could be improved?"
msgstr "Mitä voisi parantaa?"

#: src/modules/visit/FeedbackModal.tsx
msgid "What went well?"
msgstr "Mikä meni hyvin?"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Where is the property located?"
msgstr "Missä kiinteistö sijaitsee?"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Window cleaning"
msgstr "Ikkunoiden pesu"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Winter"
msgstr "Talvi"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Winter tasks"
msgstr "Talven tehtävät"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "winter's"
msgstr "talven"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Wire transfer"
msgstr "Tilisiirto"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Wire transfer instructions"
msgstr "Tilisiirto-ohjeet"

#: src/modules/maintenance/components/MarkkuSavingsCard.tsx
msgid "With the Markku package, you save {savedHours}h per year and {savedTasks} maintenance tasks"
msgstr "Markku-paketilla vapautat {savedHours}h vuodessa ja {savedTasks} huoltotyötä"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
msgid "Work completion date"
msgstr "Työn suorittamisen päivämäärä"

#: src/routes/_app/maintenance-log/index.tsx
msgid "Year"
msgstr "Vuosi"

#: src/modules/consumption/index.tsx
#: src/modules/consumption/index.tsx
msgid "Year {selectedYear} consumption"
msgstr "Vuoden {selectedYear} kulutus"

#: src/modules/costs/CostsPage/index.tsx
#: src/modules/costs/CostsPage/index.tsx
msgid "Year {year} cost tracking"
msgstr "Vuoden {year} kustannusseuranta"

#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Year {year} summary"
msgstr "Vuoden {year} yhteenveto"

#: src/routes/_app/maintenance.tsx
msgid "Year calendar"
msgstr "Vuosikello"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Year progress"
msgstr "Vuoden edistyminen"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "You can add an optional cost in euros if you also want to track your expenses"
msgstr "Voit lisätä valinnaisen kustannuksen euroina, jos haluat seurata myös menojasi"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "You can also add costs directly on this page using the \"Add\" button"
msgstr "Voit myös lisätä kustannuksia suoraan tällä sivulla \"Lisää\"-painikkeella"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "You can change to another package at any time."
msgstr "Voit vaihtaa toiseen pakettiin milloin vain."

#: src/modules/auth/WelcomeStep.tsx
msgid "You must accept the terms of service to continue."
msgstr "Sinun tulee hyväksyä käyttöehdot jatkaaksesi."

#: src/modules/auth/WelcomeLogin.tsx
msgid "You must log in to continue."
msgstr "Sinun täytyy kirjautua jatkaaksesi."

#: src/components/profile/NotificationSettings.tsx
msgid "You receive notifications on this device"
msgstr "Saat ilmoitukset tähän laitteeseen"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskInfo.tsx
msgid "Your browser does not support the video tag."
msgstr "Selaimesi ei tue video-elementtiä."

#: src/modules/visit/FeedbackModal.tsx
msgid "Your feedback has been saved successfully."
msgstr "Palautteesi on tallennettu onnistuneesti."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Your free survey visit has been booked"
msgstr "Ilmainen kartoituskäyntisi on varattu"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Your maintenance log is now ready to use"
msgstr "Huoltokirjasi on nyt valmis käyttöön"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Your Markku package"
msgstr "Oma Markku-pakettisi"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Your property has been added!"
msgstr "Kiinteistösi on lisätty!"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Your property value is preserved"
msgstr "Kiinteistösi arvo säilyy"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/BookingSummary.tsx
msgid "Your selected time"
msgstr "Valitsemasi aika"
